var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',{staticClass:"btn btn-mjf-green btn-outline btn-xs font create-new-pl-button",attrs:{"data-gtm-event":"private-link|createNew-button","disabled":_vm.disabled},on:{"click":_vm.onClick}},[_c('i',{staticClass:"btn-icon icon-plus-sign"}),_vm._v("CREATE NEW ")])
}
var staticRenderFns = []

export { render, staticRenderFns }